import { DossierId } from '@/dossier/models/AbstractDossier';
import Identity from '@/general/models/Identity';
import Job from '@/jobs/models/Job';
import ChatType from '@/shared/constants/ChatType';
import ChatPage from '../constants/ChatPage';
import parseChatContent, { ChatContentElement } from '../utils/parseChatContent';
import Chat from './Chat';
import ChatContext from './ChatContext';
import ChatGroup from './ChatGroup';
import ChatMentionTarget from './ChatMentionTarget';
import ChatMessage, { ChatJob } from './ChatMessage';
import ChatTargetContainer from './ChatTargetContainer';
import ChatUser from './ChatUser';

export default class InternalChatContext extends ChatContext {
  jobs: Array<Job> = [];
  job: Job | null = null;
  mentionQuery = '';

  constructor(
    chat: Chat,
    currentUser: Identity,
    dossierId: DossierId,
    readonly targets = ChatTargetContainer.EMPTY,
  ) {
    super(ChatType.INTERNAL, chat, currentUser, dossierId);
  }

  canWrite(): boolean {
    return true;
  }

  getUsers(): Array<ChatUser> {
    return this.targets.users;
  }

  getGroups(): Array<ChatGroup> {
    return this.targets.groups;
  }

  getMentionTargets(): Array<ChatMentionTarget> {
    return [...this.getGroups(), ...this.getUsers()];
  }

  parseChatContent(content: string): Array<ChatContentElement> {
    return parseChatContent(content, this.getMentionTargets());
  }

  selectMention(query = ''): void {
    this.mentionQuery = query;
    this.page = ChatPage.MENTION;
  }

  cancelMention(): void {
    if (this.page === ChatPage.MENTION) {
      this.mentionQuery = '';
      this.resetPage();
    }
  }

  afterSend(messages: Array<ChatMessage>): void {
    if (this.job) {
      const chatJob = ChatJob.fromJob(this.job, this.currentUser);
      messages.forEach(m => m.job = chatJob);
      this.job = null;
    }
    this.mentionQuery = '';
    super.afterSend(messages);
  }
}